import { useState, useEffect } from 'react';

const useUbigeo = (
  disabled: boolean,
  generalApi: any,
  selectedDepartment: string,
  selectedProvince: string
) => {
  const [departments, setDepartments] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);

  useEffect(() => {
    const getDepartments = async () => {
      const result = await generalApi.get('/departments');
      if (!result.success) return;
      setDepartments(Array.isArray(result.data) ? result.data : []);
    };
    if (!disabled) getDepartments();
  }, [generalApi, disabled]);

  useEffect(() => {
    // Evita pedir provincias si aún no hay departamento seleccionado
    if (disabled || !selectedDepartment) {
      setProvinces([]);
      return;
    }
    const getProvinces = async () => {
      const result = await generalApi.get(`/provinces/${selectedDepartment}`);
      if (!result.success) return;
      setProvinces(Array.isArray(result.data) ? result.data : []);
    };
    getProvinces();
  }, [generalApi, disabled, selectedDepartment]);

  useEffect(() => {
    if (disabled || !selectedProvince) {
      setDistricts([]);
      return;
    }
    const getDistricts = async () => {
      const result = await generalApi.get(`/districts/${selectedProvince}`);
      if (!result.success) return;
      setDistricts(Array.isArray(result.data) ? result.data : []);
    };
    getDistricts();
  }, [generalApi, disabled, selectedProvince]);

  return [departments, provinces, districts];
};

export { useUbigeo };